export const dummyUsers = [
  // Super Admin
  { id: 1, email: "udisantoso@example.com", password: "123", name: "Budi Santoso", role: "Super Admin" },
  { id: 2, email: "rinadewi@example.com", password: "123", name: "Rina Dewi", role: "Super Admin" },
  { id: 3, email: "ahmadyusuf@example.com", password: "123", name: "Ahmad Yusuf", role: "Super Admin" },
  { id: 4, email: "linamarlina@example.com", password: "123", name: "Lina Marlina", role: "Super Admin" },
  { id: 5, email: "danielsimanjuntak@example.com", password: "123", name: "Daniel Simanjuntak", role: "Super Admin" },

  // Admin
  { id: 6, email: "andisaputra@example.com", password: "123", name: "Andi Saputra", role: "Admin" },
  { id: 7, email: "sariwulandari@example.com", password: "123", name: "Sari Wulandari", role: "Admin" },
  { id: 8, email: "rizkyhidayat@example.com", password: "123", name: "Rizky Hidayat", role: "Admin" },
  { id: 9, email: "dewilestari@example.com", password: "123", name: "Dewi Lestari", role: "Admin" },
  { id: 10, email: "hendragunawan@example.com", password: "123", name: "Hendra Gunawan", role: "Admin" },

  // Admin HR
  { id: 11, email: "fitriani@example.com", password: "123", name: "Fitriani", role: "Admin HR" },
  { id: 12, email: "yudipratama@example.com", password: "123", name: "Yudi Pratama", role: "Admin HR" },
  { id: 13, email: "sintamarbun@example.com", password: "123", name: "Sinta Marbun", role: "Admin HR" },
  { id: 14, email: "arifnugroho@example.com", password: "123", name: "Arif Nugroho", role: "Admin HR" },
  { id: 15, email: "niaramadhani@example.com", password: "123", name: "Nia Ramadhani", role: "Admin HR" },

  // Admin Finance
  { id: 16, email: "bayusaputro@example.com", password: "123", name: "Bayu Saputro", role: "Admin Finance" },
  { id: 17, email: "lilissuryani@example.com", password: "123", name: "Lilis Suryani", role: "Admin Finance" },
  { id: 18, email: "taufikakbar@example.com", password: "123", name: "Taufik Akbar", role: "Admin Finance" },
  { id: 19, email: "megaputri@example.com", password: "123", name: "Mega Putri", role: "Admin Finance" },
  { id: 20, email: "doniwahyudi@example.com", password: "123", name: "Doni Wahyudi", role: "Admin Finance" },

  // Field Agent
  { id: 21, email: "jokosantosa@example.com", password: "123", name: "Joko Santosa", role: "Field Agent" },
  { id: 22, email: "lisapurnama@example.com", password: "123", name: "Lisa Purnama", role: "Field Agent" },
  { id: 23, email: "rahmathidayat@example.com", password: "123", name: "Rahmat Hidayat", role: "Field Agent" },
  { id: 24, email: "mayanuraini@example.com", password: "123", name: "Maya Nuraini", role: "Field Agent" },
  { id: 25, email: "dedisusanto@example.com", password: "123", name: "Dedi Susanto", role: "Field Agent" },

  // R&D
  { id: 26, email: "kevinprasetyo@example.com", password: "123", name: "Kevin Prasetyo", role: "R&D" },
  { id: 27, email: "rizkamaulida@example.com", password: "123", name: "Rizka Maulida", role: "R&D" },
  { id: 28, email: "ekasiregar@example.com", password: "123", name: "Eka Siregar", role: "R&D" },
  { id: 29, email: "antonsembiring@example.com", password: "123", name: "Anton Sembiring", role: "R&D" },
  { id: 30, email: "selvioctavia@example.com", password: "123", name: "Selvi Octavia", role: "R&D" },

  // Marketing
  { id: 31, email: "arismunandar@example.com", password: "123", name: "Aris Munandar", role: "Marketing" },
  { id: 32, email: "yuliana@example.com", password: "123", name: "Yuliana", role: "Marketing" },
  { id: 33, email: "dimasaditya@example.com", password: "123", name: "Dimas Aditya", role: "Marketing" },
  { id: 34, email: "indahpermata@example.com", password: "123", name: "Indah Permata", role: "Marketing" },
  { id: 35, email: "rezamahendra@example.com", password: "123", name: "Reza Mahendra", role: "Marketing" },

  // Mitra
  { id: 36, email: "mitraa@example.com", password: "123", name: "Mitra A", role: "Mitra" },
  { id: 37, email: "mitrab@example.com", password: "123", name: "Mitra B", role: "Mitra" },
  { id: 38, email: "mitrac@example.com", password: "123", name: "Mitra C", role: "Mitra" },
  { id: 39, email: "mitrad@example.com", password: "123", name: "Mitra D", role: "Mitra" },
  { id: 40, email: "mitrae@example.com", password: "123", name: "Mitra E", role: "Mitra" },
];
